import React from 'react';
import { observer } from "mobx-react-lite";
import { BooleanActionDetail } from './BooleanActionDetail';
import { useTranslation } from 'react-i18next';
import { MapElementSelector } from '../../selector/MapElementSelector';
import { formatTreeParameter, parseFormattedTreeParameter } from "../../../../../shared/helper/actionTreeHelper";
import { editorMapStore, MapStatus } from '../../../../stores/EditorMapStore';
import { sharedStore } from '../../../../stores/SharedStore';
import { AnimationElementValueModel } from '../../../../../shared/action/ValueModel';
import { isBlank } from '../../../../../shared/helper/generalHelpers';
import { Dropdown } from '../../../editor/Dropdown';
import { getTreeParentOfClosestActionModel } from '../../../../../shared/action/ActionTreeModel';
import { ElementParameter } from '../../../editor/ElementIcons';
import { getImageForElement } from '../../../../helper/mapElementIconHelper';
import { ElementGroup, ElementLabel } from './BaseElements';
export const AnimationElementSelectionDetail = observer(({
  name,
  selectedAnimationElement,
  animationElementSetter,
  allowBlankValue
}) => {
  const {
    t
  } = useTranslation();
  const parentTree = getTreeParentOfClosestActionModel(selectedAnimationElement, true);
  const animationElementTreeParameters = parentTree.treeParameterActions("actions/AnimationElementValueModel");
  const parameters = animationElementTreeParameters.map(a => formatTreeParameter(a.name));

  const getElements = mapId => {
    if (mapId === 0) {
      return {
        mapStatus: MapStatus.Loaded,
        mapName: undefined,
        elements: parameters.map(parameter => ({
          id: parameter,
          label: parameter,
          icon: /*#__PURE__*/React.createElement(ElementParameter, {
            key: parameter
          })
        }))
      };
    }

    const {
      map,
      mapStatus
    } = editorMapStore.getOrLoadMapWithMetaData(mapId, true);
    const animationElements = map ? map.animationElements : [];
    return {
      mapStatus,
      mapName: map === null || map === void 0 ? void 0 : map.properties.name,
      elements: animationElements.map(a => ({
        id: a.$modelId,
        label: a.label === "" ? a.animationName : a.label + ` (${a.animationName})`,
        image: getImageForElement(a)
      }))
    };
  };

  let animationNames = null;
  const treeParameterName = parseFormattedTreeParameter(selectedAnimationElement.elementId);

  if (treeParameterName) {
    const treeParameter = animationElementTreeParameters.find(p => p.name === treeParameterName);

    if (treeParameter && treeParameter.value instanceof AnimationElementValueModel && treeParameter.value.hasRequiredAnimationNames) {
      animationNames = treeParameter.value.requiredAnimationNames;
    }
  } else {
    var _map$animationElement;

    const map = editorMapStore.getOrLoadMapWithMetaData(selectedAnimationElement.mapId, true).map;
    const animation = sharedStore.getAnimationByName(map === null || map === void 0 ? void 0 : (_map$animationElement = map.animationElements.find(a => a.$modelId === (selectedAnimationElement === null || selectedAnimationElement === void 0 ? void 0 : selectedAnimationElement.elementId))) === null || _map$animationElement === void 0 ? void 0 : _map$animationElement.animationName);

    if (animation) {
      animationNames = animation.animationNames;
    }
  }

  return /*#__PURE__*/React.createElement(ElementGroup, null, /*#__PURE__*/React.createElement(ElementLabel, null, name), /*#__PURE__*/React.createElement(MapElementSelector, {
    selectedElement: selectedAnimationElement,
    elementSetter: animationElementSetter,
    elementsGetter: getElements,
    allowBlankValue: allowBlankValue
  }), animationNames && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), t("action_editor.property_animation_name"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Dropdown, {
    className: !allowBlankValue && isBlank(selectedAnimationElement.animationName) ? "invalid" : "",
    value: selectedAnimationElement.animationName,
    onChange: ({
      target
    }) => selectedAnimationElement.setAnimationName(target.value)
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }), animationNames.map(animation => /*#__PURE__*/React.createElement("option", {
    key: animation,
    value: animation
  }, animation))), /*#__PURE__*/React.createElement(BooleanActionDetail, {
    name: t("action_editor.property_loop_animation"),
    checked: selectedAnimationElement.loop,
    toggle: () => selectedAnimationElement.toggleLoop()
  })));
});